import { Field, FieldProps, getIn } from 'formik';
import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { spacing02 } from '../../../styling/spacing';
import { FieldLabel } from '../FieldLabel';
import { FormContext } from '../Form';
import { FieldContainer, FormField, InputAndErrorContainer, InputContainer } from '../FormField';
import { Checkbox } from './Checkbox';

type CheckboxFieldProps = {
  name: string;
  label: string | null;
  className?: string;
  onChange?: (newValue: string) => void;
  disabled?: boolean;
};

export const CheckboxField = (props: CheckboxFieldProps) => {
  const formIsDisabled = useContext(FormContext).isDisabled;

  return (
    <FieldContainer className={props.className}>
      <Field name={props.name}>
        {({ form, field }: FieldProps) => {
          const touched = getIn(form.touched, props.name);
          const error = getIn(form.errors, props.name);
          const isValid: boolean = touched && !error;
          const isInvalid: boolean = touched && error;
          const showError: boolean = touched && error;

          return (
            <InputAndErrorContainer>
              <InputContainer>
                <Checkbox
                  {...field}
                  id={field.name}
                  data-testid={checkboxFieldTestId(props.name)}
                  $isValid={isValid}
                  $isInvalid={isInvalid}
                  disabled={formIsDisabled || props.disabled || form.isSubmitting}
                  checked={field.value === true}
                />
                <StyledFieldLabel label={props.label} showError={showError} error={error} fieldName={props.name} />
              </InputContainer>
            </InputAndErrorContainer>
          );
        }}
      </Field>
    </FieldContainer>
  );
};

export const VerticalCheckboxField = (props: CheckboxFieldProps) => {
  const formIsDisabled = useContext(FormContext).isDisabled;

  return (
    <FormField name={props.name} label={props.label} className={props.className}>
      {({ field, form, $isValid, $isInvalid }) => {
        return (
          <Checkbox
            {...field}
            data-testid={checkboxFieldTestId(props.name)}
            $isValid={$isValid}
            $isInvalid={$isInvalid}
            disabled={formIsDisabled || props.disabled || form.isSubmitting}
            checked={field.value === true}
          />
        );
      }}
    </FormField>
  );
};

export const checkboxFieldTestId = (fieldName: string) => `checkbox-field-${fieldName}`;

const StyledFieldLabel = styled(FieldLabel)`
  margin: 0 0 0 ${spacing02};
`;
